import { BaseStatementPagePath } from "app/core/workflow/page-path/statement-page-path/base-statement-page.path";

export class AdditionalOptionsComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return "statement/:statementId/additional-options/:step";
  }

  public static pathWithoutStep(): string {
    return "statement/:statementId/additional-options";
  }

  public static regex(step?: number): RegExp {
    return this.componentRegex(this.path(), null, step);
  }
}
